import { PageContentAnimation } from '../../../../components/layout';
import { CompanyRentalAgreementsCard } from '../components/company-rental-agreements/company-rental-agreements-card.component';

export function CompanyAgreementsTab() {
  return (
    <PageContentAnimation>
      <CompanyRentalAgreementsCard />
    </PageContentAnimation>
  );
}
